import Loader from "../../DomUtilities/Loader";
import openErrorModal from "../../Error/ErrorModal";
import { fetchNextOrderStatus } from "../../HTTPRequests/OrderRequests";
import MoveOrderNextStatusModel from "../../Models/ViewModels/MoveOrderNextStatusModel";

export default class OrderMoveNextStatusModal {
	forwardIcon: HTMLElement;
	moveNextStatusModal: HTMLDivElement;
	buttonsWrapper: HTMLDivElement;
	model: MoveOrderNextStatusModel[];
	id: string;

	constructor(model: MoveOrderNextStatusModel[]) {
		this.forwardIcon = document.createElement("i");
		this.forwardIcon.classList.add("icon-forward");
		this.forwardIcon.title = "Next";
		this.model = model;
		this.moveNextStatusModal = document.querySelector('#move-next-status');
		this.buttonsWrapper = this.moveNextStatusModal.querySelector('.btns');
	}

	public init(orderId: string): HTMLElement {
		this.forwardIcon.onclick = (event) => {
			event.stopPropagation();
			this.id = orderId;
			if (this.model.length === 1) {
				this.sendRequest(this.model[0].command);
			} else {
				this.openModal();
			}
		}

		return this.forwardIcon;
	}

	private openModal() {
		this.buttonsWrapper.innerHTML = "";

		this.model.forEach(i => {
			const btn = document.createElement('button');
			btn.innerText = i.status;
			btn.classList.add("submit-btn");

			btn.style.backgroundColor = i.color;
			btn.onmouseenter = () => {
				btn.style.backgroundColor = `${i.color}D4`;
			}
			btn.onmouseleave = () => {
				btn.style.backgroundColor = i.color;
			}

			this.buttonsWrapper.appendChild(btn);

			btn.onclick = () => {
				this.moveNextStatusModal.style.display = "none";
				this.sendRequest(i.command);

			}
		});
		this.moveNextStatusModal.style.display = "flex";

		this.addModalClickListeners();
	}

	private addModalClickListeners() {
		const closeImg: HTMLImageElement = this.moveNextStatusModal.querySelector('img[alt="close icon"]');
		closeImg.onclick = () => {
			this.moveNextStatusModal.style.display = "none";
		}

		this.moveNextStatusModal.onclick = (event) => {
			if (this.moveNextStatusModal.style.display !== "none" && event.target === this.moveNextStatusModal) {
				this.moveNextStatusModal.style.display = "none";
			}
		}
	}

	private sendRequest(command: string) {
		Loader.show();
		fetchNextOrderStatus(this.id, command)
			.then(() => {

			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}
}
